// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.department-dropdown-icon {
    height: 20px;
    position: absolute;
    right: 10px;
  }
    
    .department-dropdown-icon-wrapper {
      position: relative;
      float: right;
      padding-right: 10px;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 30px;
      color: black;
    }
    
    .department-dropdown-icon-wrapper:hover:first-child {
          color: var(--btn-color-primary-0)
        }
  .department-dropdown-wrapper {
    padding-left: 20px;
    max-height: 30px;
    max-width: 30px;
  }
  .department-dropdown-options {
    width: 125px;
    cursor: pointer;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .department-dropdown-options > h3 {
      margin: 13px auto;
      text-align: center;
      font-size: 16px;
      font-weight: 100;
    }
  .department-dropdown-options:first-child {
      border-bottom: 1px solid #e5e5ea;
    }
  .department-dropdown-options-delete {
      color: red;
    }
  .department-dropdown-options-delete:hover {
        color: red;
      }
  .department-dropdown-options-wrapper {
      width: 125px;
      background-color: #f5f6f7;
      color: black;
      top: 15px;
      right: 125px;
      border: 1px solid #e5e5ea;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      z-index: 10;
      position: relative;
      box-shadow: 0 10px 20px 0 rgb(0 0 0 / 20%);
      border-radius: 5px;
    }

`, "",{"version":3,"sources":["webpack://./app/components/DepartmentDetailSidebar/components/DepartmentDropdown/style.css"],"names":[],"mappings":"AACE;IACE,YAAY;IACZ,kBAAkB;IAClB,WAAW;EAmBb;;IAjBE;MACE,kBAAkB;MAClB,YAAY;MACZ,mBAAmB;MACnB,eAAe;MACf,aAAa;MACb,mBAAmB;MACnB,uBAAuB;MACvB,YAAY;MACZ,YAAY;IAOd;;IAJI;UACE;QACF;EAKN;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;EAEA;IACE,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EAqCzB;EAnCE;MACE,iBAAiB;MACjB,kBAAkB;MAClB,eAAe;MACf,gBAAgB;IAClB;EAEA;MACE,gCAAgC;IAClC;EAEA;MACE,UAAU;IAKZ;EAHE;QACE,UAAU;MACZ;EAGF;MACE,YAAY;MACZ,yBAAyB;MACzB,YAAY;MACZ,SAAS;MACT,YAAY;MACZ,yBAAyB;MACzB,aAAa;MACb,sBAAsB;MACtB,uBAAuB;MACvB,mBAAmB;MACnB,WAAW;MACX,kBAAkB;MAClB,0CAA0C;MAC1C,kBAAkB;IACpB","sourcesContent":[".department-dropdown {\n  &-icon {\n    height: 20px;\n    position: absolute;\n    right: 10px;\n    \n    &-wrapper {\n      position: relative;\n      float: right;\n      padding-right: 10px;\n      cursor: pointer;\n      display: flex;\n      align-items: center;\n      justify-content: center;\n      height: 30px;\n      color: black;\n\n      &:hover {\n        &:first-child {\n          color: var(--btn-color-primary-0)\n        }\n      }\n    }\n  }\n  \n  &-wrapper {\n    padding-left: 20px;\n    max-height: 30px;\n    max-width: 30px;\n  }\n\n  &-options {\n    width: 125px;\n    cursor: pointer;\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n\n    & > h3 {\n      margin: 13px auto;\n      text-align: center;\n      font-size: 16px;\n      font-weight: 100;\n    }\n\n    &:first-child {\n      border-bottom: 1px solid #e5e5ea;\n    }\n\n    &-delete {\n      color: red;\n\n      &:hover {\n        color: red;\n      }\n    }\n\n    &-wrapper {\n      width: 125px;\n      background-color: #f5f6f7;\n      color: black;\n      top: 15px;\n      right: 125px;\n      border: 1px solid #e5e5ea;\n      display: flex;\n      flex-direction: column;\n      justify-content: center;\n      align-items: center;\n      z-index: 10;\n      position: relative;\n      box-shadow: 0 10px 20px 0 rgb(0 0 0 / 20%);\n      border-radius: 5px;\n    }\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
